import { useState } from 'react';

const faqs = [
  {
    question: '韩漫大全的漫画资源是否为正版？',
    answer: '韩漫大全始终坚持正版授权原则，所有漫画内容均获得韩国版权方的正式授权。我们与多家韩国知名漫画平台建立了深度合作关系，确保每一位读者都能在合法合规的前提下享受高品质的阅读体验。',
  },
  {
    question: '什么是"无删减"韩漫？',
    answer: '"无删减"韩漫指的是保留原作完整内容的版本，不经过任何删改或阉割处理。韩漫大全严格遵循这一标准，为读者提供原汁原味的韩国漫画作品，让您感受到原作最真实的魅力和情感表达。',
  },
  {
    question: '什么是"下拉式"阅读模式？',
    answer: '"下拉式"阅读是一种专为移动端和网页端优化的漫画阅读方式。读者只需向下滚动页面，漫画内容便会连续不间断地呈现，无需翻页操作。这种模式起源于韩国网络漫画（Webtoon），现已成为全球漫画阅读的主流方式。',
  },
  {
    question: '如何注册成为韩漫大全会员？',
    answer: '注册流程非常简单。点击页面右上角的用户图标，填写基本的邮箱和密码信息即可完成注册。注册会员后，您可以收藏喜欢的漫画、收到更新提醒，并享受更多专属会员权益。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '韩漫大全拥有专业的翻译和更新团队，大部分热门连载漫画保持每周更新的频率，部分高热作品甚至能达到每周多更。我们确保在韩国原作更新后的48小时内完成中文翻译和发布，让您几乎与韩国读者同步追更。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于韩漫大全的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-secondary-50 transition-colors"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 w-5 h-5 flex items-center justify-center ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}